// extracted by mini-css-extract-plugin
module.exports = {"neutral100":"#f6f5fa"};